import React, {forwardRef, memo, useMemo, useState} from "react";
import styles from "./question-content.module.css";
import {countCharLength} from "src/utils/ValidationUtils";
import PuiTypography from "src/components/elements/PuiTypography";
import {Checkbox, CheckboxProps, Grid, Radio, RadioProps, withStyles} from "@material-ui/core";
import Countdown, {CountdownRenderProps, zeroPad} from "react-countdown";
import {Survey} from "src/models/survey";
import SkipNextIcon from "@material-ui/icons/SkipNext";
import SendIcon from "@material-ui/icons/Send";
import {useSelector} from "react-redux";
import {AppState} from "src/root/RootReducer";
import SurveyApi from "src/store/apis/SurveyApi";
import {useRouteLoaderData} from "react-router-dom";
export interface QuestionContentProps {
  questionIdx: number;
  survey: Survey;
  onNext:() => void;
}

const SurveyCheckbox = withStyles({
    root: {
        color: "var(--gray-42)",
        "&$checked": {
            color: "var(--white)"
        }
    },
    checked: {}
})((props: CheckboxProps) => (
    <Checkbox size="medium" color="default" {...props}/>
));

const SurveyRadio = withStyles({
    root: {
        color: "var(--gray-42)",
        "&$checked": {
            color: "var(--white)"
        }
    },
    checked: {}
})((props: RadioProps) => (
    <Radio size="medium" color="default" name="optionRadio" {...props}/>
));

const QuestionContent = forwardRef<HTMLDivElement,QuestionContentProps>(
    ({questionIdx,survey,onNext},ref) => {
        const question = survey.questionList[questionIdx];
        const [state,setState] = useState(() => question.choiceList.map(() => false));
        const answered = Object.values(state).some(item => item);

        const [timerRestart, setTimerRestart] = useState<boolean>(false);
        const timerRenderer = (props: CountdownRenderProps) => {
            if (timerRestart) {
                props.api.start();
                setTimerRestart(false);
            }
            return (
                <>
                    {zeroPad(props.minutes)}:{zeroPad(props.seconds)}
                </>
            );
        };
        const countDownTime = useMemo(
            () => Date.now() + question.displayMillis,
            [question.displayMillis]
        );

        const handleClick = (choiceIdx: number) => {
            if (question.answerType === 0) {
                setState((current) => {
                    const newVal = current.map(() => false);
                    newVal[choiceIdx] = true;
                    return newVal;
                });
            } else {
                setState((current) => {
                    const newVal = [...current];
                    newVal[choiceIdx] = !newVal[choiceIdx];
                    return newVal;
                });
            }
        };

        const {userInfo} =
      useSelector((state: AppState) => {
          return {
              userInfo: state.user.userInfo
          };
      });


        const videoData = useRouteLoaderData("videoDetail") as {
          id: string
        };
        const handleSendAnswer = async () => {
            const answerList = state
                .map((item,idx) =>  item ? question.choiceList[idx].choiceId : undefined)
                .filter(item => item !== undefined);


            SurveyApi.AddSurveyAnswer(
                parseInt(userInfo.id),
                parseInt(videoData.id),
                survey.surveyId,
                question.questionId,
                answerList
            );
            onNext();

        };



        const sendAnswerButton = (
            <div className={styles.sendAnswer} onClick={handleSendAnswer}>
                <PuiTypography size={16} color="white">
          回答を送信
                </PuiTypography>
                <SendIcon style={{color: "white"}}/>
            </div>
        );

        const skipButton = (
            <div className={styles.skip} onClick={onNext}>
                <PuiTypography size={16} color="white">
          スキップ
                </PuiTypography>
                <SkipNextIcon style={{color: "white"}}/>
            </div>
        );
        return (
            <div
                tabIndex={-1}
                ref={ref}
                className={styles.wrapper}
                style={{
                    height: `${
                        305 +
                question?.choiceList.length *
                75 +
                Math.floor(
                    countCharLength(
                        question?.content
                    ) / 52
                ) *
                28
                    }px`
                }}
            >
                <div className={styles.questionTitle}>
                    <div className={styles.title}>
                        <PuiTypography size={24} bold={true} color="white">{`設問${
                            questionIdx + 1
                        }（${
                            question?.answerType === 0
                                ? "単一回答"
                                : "複数回答"
                        }）`}</PuiTypography>
                    </div>
                    <div
                        className={styles.subTitle}
                        style={{
                            height: `${
                                Math.ceil(
                                    countCharLength(
                                        question?.content
                                    ) / 52
                                ) * 28
                            }px`
                        }}
                        data-tip={question?.content}
                        data-for="subTitle"
                    >
                        <PuiTypography size={20} bold={true} color="white" rows={3}>
                            {`${question?.content}`}
                        </PuiTypography>
                    </div>
                </div>
                <div>
                    <Grid container>
                        {
                            question.choiceList.map((choice, index) => {
                                const isSelected = !!state[index];
                                return  (
                                    <Grid container item xs={12} spacing={2} key={choice.choiceId}>
                                        <Grid item xs={12}>
                                            <div
                                                className={isSelected ? styles.selected : styles.unselected}
                                                onClick={() => handleClick(index)}
                                            >
                                                {question?.answerType === 0 ? (
                                                    <SurveyRadio checked={isSelected}/>
                                                ) : (
                                                    <SurveyCheckbox checked={isSelected}/>
                                                )}
                                                <PuiTypography size={16} bold={true} color="white">
                                                    {
                                                        choice
                                                            .content
                                                    }
                                                </PuiTypography>
                                            </div>
                                        </Grid>
                                    </Grid>
                                );
                            })
                        }
                    </Grid>
                </div>
                <div className={styles.controllWrapper}>
                    <div>
                        {question?.skipFlag &&
                skipButton}
                    </div>
                    <div>{answered && sendAnswerButton}</div>
                </div>
                <div className={styles.footerWrapper}>
                    {question?.displayMillis > 0 ? (
                        <PuiTypography size={14} color="white">
                残り時間 (
                            <Countdown
                                date={countDownTime}
                                renderer={(props) => timerRenderer(props)}
                                onComplete={onNext}
                            />
                )
                        </PuiTypography>
                    ) : (
                        <div/>
                    )}
                    <div>
                        <PuiTypography size={14} color="white">{`(${questionIdx + 1}/${
                            survey.questionList.length
                        })`}</PuiTypography>
                    </div>
                </div>
            </div>
        );
    });

export default memo(QuestionContent);
